import { KeyboardEvent } from "react";

const BLOCKED_KEYS = ["e", "E", "+", "-", ".", ","];

export const blockNonIntegerKeys = (e: KeyboardEvent<HTMLInputElement>): void => {
  if (BLOCKED_KEYS.includes(e.key)) {
    e.preventDefault();
  }
};

export const sanitizeIntegerInput = (value: string): string => value.replace(/[^0-9]/g, "");
